export const suggestions = [
  {
    videoId: 'IZ3XMOdOdKM',
    title: 'Miley Cyrus - Used To Be Young (Official Video)',
  },
  {
    videoId: 'g0Q5YeZ4YOA',
    title: 'Why is the world warming up? | Kristen Bell + Giant Ant',
  },
  {
    videoId: 'o_XVt5rdpFY',
    title: 'The secrets of learning a new language | Lýdia Machová',
  },
  {
    videoId: 'GfO-3Oir-qM',
    title: 'Our Planet | One Planet | FULL EPISODE | Netflix',
  },
  {
    playlistId: 'PL30C13C91CFFEFEA6',
    videoId: 'kBdfcR-8hEY',
    url: 'https://www.youtube.com/watch?v=kBdfcR-8hEY&list=PL30C13C91CFFEFEA6&index=1&ab_channel=HarvardUniversity',
    img: 'https://pnl.dev/assets/uploads/files/1608889019866-9bbd99c2-3fed-4fcf-9ba5-f25f027cec5d-image.png',
    title: "Justice: What's The Right Thing To Do?",
  },
  {
    videoId: 'lUUte2o2Sn8',
    title: "Gil Strang's Final 18.06 Linear Algebra Lecture",
  },
];
